import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl, Validators, ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-numeric',
  templateUrl: './input-numeric.component.html',
  styleUrls: ['./input-numeric.component.css']
})
export class InputNumericComponent implements OnInit, OnChanges
{
 
  constructor() { }
  
    @Input() ValidarRequerido: boolean;
    @Input() PermiteDecimales: boolean = true;

    @Input() placeHolderValue: string = "";

    @Input() inputNumericFormControl: FormGroup;

    CantidadDecimales: number = 1;

    DeshabilitarControl: boolean = false;
    @Input() set disabled(value: boolean) {
        var $this = this;
        setTimeout(function () {
            $this.DeshabilitarControl = value;
        });
    }
    @Input() actualizarFormato: boolean;

    ngOnInit(): void
    {
        var _validadores: any[] = [];
        
        if (this.ValidarRequerido)
        {
            _validadores.push(Validators.required)
        }

      this.inputNumericFormControl.addControl("importe", new FormControl('', _validadores));
    }

    ngOnChanges(changes: SimpleChanges): void
    {
      if (changes.actualizarFormato.currentValue == true)
      {
        let numero = parseFloat(this.inputNumericFormControl.get("importe").value.toString()).toFixed(2);
        if(numero == 'NaN' || numero == ''){
          numero = '0.0';
        }
        this.formatearImporte(numero);
      }
    }

    formatear()
    {
      if (this.inputNumericFormControl.get("importe").value.toString() != '')
      {
        let numero = parseFloat(this.inputNumericFormControl.get("importe").value.toString().replaceAll(".", "").replaceAll(",", ".")).toFixed(2);
        this.formatearImporte(numero);
      }
    }

    private formatearImporte(numero: string)
    {
        let numeroDecimal = numero.split(".");
        let parteEntera = numeroDecimal[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.inputNumericFormControl.get("importe").setValue(parteEntera + "," + numeroDecimal[1]);
    }
}
